import Link from "next/link";
import { HelpCircle } from "lucide-react";
import {
  HOW_TO_USE_PATH,
  HOW_TO_USE_LABEL,
  CAREER_STAGE_OPTIMIZATION_NOTICE,
} from "@/data/evaluationGuide";

interface GuideNoticeProps {
  /** 外側の余白調整用（配置画面ごとに上書きする）。 */
  className?: string;
}

/**
 * ログイン・練習・面接の各画面上部に置く、使い方ページへの軽量な案内。
 * 文言・リンク先は evaluationGuide.ts の単一ソースを参照する。
 */
export default function GuideNotice({ className = "" }: GuideNoticeProps) {
  return (
    <div
      className={`flex items-start gap-3 rounded-2xl border border-border bg-surface-container-low px-4 py-3.5 ${className}`}
    >
      <span
        aria-hidden="true"
        className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-lg bg-[#fdf0ee] text-primary"
      >
        <HelpCircle size={18} />
      </span>
      <div>
        <p className="text-[13.5px] leading-relaxed">
          はじめての方は{" "}
          <Link
            href={HOW_TO_USE_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-primary hover:underline"
          >
            {HOW_TO_USE_LABEL}
            <span className="sr-only">（別タブで開く）</span>
          </Link>{" "}
          をご覧ください。
        </p>
        <p className="mt-0.5 text-xs leading-relaxed text-subtext">
          {CAREER_STAGE_OPTIMIZATION_NOTICE}
        </p>
      </div>
    </div>
  );
}
